import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import axios from 'axios';
import './Services.css';

const serviceIcons = ['✂️', '🎨', '✨', '💆', '💧', '👰', '💅'];

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    axios.get('/api/services').then(r => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="section-header">
          <span className="section-eyebrow">O que oferecemos</span>
          <h2 className="section-title">Nossos Serviços</h2>
          <div className="gold-line" />
          <p className="section-subtitle">
            Serviços premium com produtos de alta qualidade para realçar sua beleza
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, idx) => (
            <div key={service.id} className="service-card">
              <div className="service-icon-wrap">
                <span className="service-emoji">{serviceIcons[idx] || '💄'}</span>
              </div>
              <h3 className="service-name">{service.name}</h3>
              <p className="service-desc">{service.description}</p>
              <div className="service-meta">
                <span className="service-time">
                  <Clock size={13} />
                  {service.duration_minutes} min
                </span>
                <span className="service-price">
                  R$ {service.price.toFixed(2).replace('.', ',')}
                </span>
              </div>
              <Link to="/reservar" className="service-cta">
                Agendar
              </Link>
            </div>
          ))}
        </div>

        <div className="services-cta-bar">
          <p>Não sabe qual serviço escolher? Fale com nossa equipe!</p>
          <a href="https://wa.me/5500000000000" target="_blank" rel="noreferrer" className="btn-primary">
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
